import { FC, memo } from 'react';

import { SkeletonContentGroup } from './SkeletonContentGroup';

import './ReleaseNoteCardSkeleton.scss';

interface IReleaseNoteCardSkeletonProps {
	cardCount?: number;
}

const ReleaseNoteCardSkeletonComponent: FC<IReleaseNoteCardSkeletonProps> = ({
	cardCount = 2
}: IReleaseNoteCardSkeletonProps) => {
	return (
		<>
			{Array.from({ length: cardCount }, (_, index) => (
				<div key={index} className="release-notes-content-card release-note-card-skeleton">
					<div className="changelog-section">
						<div className="patch-header">
							<div className="skeleton-release-title" />
							<div className="skeleton-release-version">
								<div className="skeleton-release-version-inner" />
							</div>
						</div>
						<div className="skeleton-release-date" />
						<div className="patch-content">
							<SkeletonContentGroup />
							<SkeletonContentGroup />
						</div>
					</div>
				</div>
			))}
		</>
	);
};

export const ReleaseNoteCardSkeleton = memo(ReleaseNoteCardSkeletonComponent);
